import { M3PEncItems } from "./m3-penc-items";
import { M3PEncFP } from "./m3-penc-fp";
import { M3PDinamicas } from "./m3-pdinamicas";
import { M3PromCombinadaXProceso } from "./m3-prom-comb";
import { M3FTrabajo } from "./m3-f-trabajo";
import { M3PEnvios } from "./m3-p-envios";
import { M3PRecepcion } from "./m3-precepcion";
import { PromocionCombinada } from "../Promociones/Models/M3PromoProcesada.class";
import { M3PerXProceso } from "./m3-per-x-proceso";
import { M3RegistroTrx } from "./m3-reg-trx";
import { M3OtClasificaciones } from "./m3-ot-clasificaciones";
import * as moment_ from 'moment';

const moment = moment_;
export class M3Procesos {
    public IdM3:string;
    public Fecha:string;
    public TipoTercero:number;
    public TDoc:string;
    public NDoc:string;
    public Ubic1:number;
    public Ubic2:number;
    public ValorNeto:number =0;
    public Valor:number =0;
    public ValOtraClasi:number =0;
    public SubEstadoDes:string;
    public EstadoDes:string;
    public SubEstadoAnt:string;
    public EstadoAnt:string;
    public TMIdProceso:string;
    public IDDiario:string;
    public IDDiarioCierre:string;
    public IDHub:number;
    public M3ENC = new Array<M3PEncItems>();
    public M3OtClasificaciones = new Array<M3OtClasificaciones>();
    public lM3PDinamicas = new Array<M3PDinamicas>();
    public M3PerXProceso = new Array<M3PerXProceso>();
    public lM3PEncFP = new Array<M3PEncFP>();
    public M3FTrabajo = new M3FTrabajo();
    public M3PEnvios = new Array<M3PEnvios>();
    public M3PRecepcion = new Array<M3PRecepcion>();
    public lM3RegistroTrx = new Array<M3RegistroTrx>();
    
    public FechaHoraEstado:string;
    public IdEstado:string;


    //Estas propiedades no son replica a base de datos, son para uso interno.
    //public lM3PromCombinada = new Array<M3PromCombinadaXProceso>();

    public PromosCombinadas = new Array<PromocionCombinada>();

    public AplPagoEnLinea:boolean = false;

    public AplDesdeServer:boolean = false;

    public ndocUActivo:string; //JAGM 20191017 Nuevos parametros,para llevar el registro del usuario activo, que creo este proceso
    public tdocUActivo:string;//JAGM 20191017 Nuevos parametros,para llevar el registro del usuario activo, que creo este proceso
    //public bAPLCombinadasAcum:boolean = false;

    constructor(){
        this.Fecha =moment(new Date()).format('YYYY-MM-DD');
    }

}